import { useQuery } from "hooks/useQuery";
import { getPerformanceDataV2 } from "features/Dashboard/service";
import { getHostDashboardMetrics } from "features/Host/service";

export const usePerformance = (title) => {
  const { isLoading, data } = useQuery({
    key: "performance",
    queryKey: ["performance", title],
    queryFn: async () => {
      if (title === "Revenue") {
        const response = await getHostDashboardMetrics();
        return response.earnings_timeseries;
      }
      const response = await getPerformanceDataV2();
      return response.charts_data;
    },
  });

  return { isLoading, data };
};
